import axiosInstance from '../variables/api/axiosInstance';

/**
 * Liaisons de sinistres - regroupements de dossiers issus d'un meme accident
 * sous un numero SL-YYYY-XXXX.
 *
 * `page` renvoie deja les membres de chaque liaison (voir
 * LiaisonSinistreResponse cote backend) : c'est la raison d'etre de sa
 * conception, en une seule requete pour toute la page plutot qu'un aller
 * retour par ligne deroulee. Ne jamais rappeler le service depuis un
 * `expandedRowRender` : ce serait reintroduire le N+1 que le backend a ete
 * concu pour ecarter.
 */
export const liaisonService = {
  /** Page de liaisons, membres inclus : le déroulé d'une ligne ne refait aucun appel. */
  page: (params = {}) => axiosInstance.get('/v1/liaisons', { params: { page: 0, size: 20, ...params } }),

  /**
   * Membres d'un lot de liaisons, en UN appel.
   *
   * Pour la liste des sinistres, qui affiche des dossiers : elle relève les
   * liaisons présentes sur sa page et les charge toutes d'un coup. Ne jamais
   * appeler ceci liaison par liaison - ce serait le N+1 que ce module écarte.
   */
  lot: (ids) => axiosInstance.get('/v1/liaisons/lot', { params: { ids: ids.join(',') } }),

  /**
   * `nouvellesCirconstances` est facultatif. Laissé vide sur un groupe qui en
   * porte déjà, il NE L'EFFACE PAS : le serveur ignore un texte vide ici, pour
   * qu'un simple rattachement ne détruise pas le récit qu'un collègue a rédigé.
   * Pour effacer, il faut passer par `majNouvellesCirconstances`.
   */
  lier: (sinistreTrackingId, cibleTrackingId, nouvellesCirconstances) =>
    axiosInstance.post(`/v1/sinistres/${sinistreTrackingId}/lier`,
      { cibleTrackingId, nouvellesCirconstances: nouvellesCirconstances || null }),

  /** Remplace le récit du regroupement. Un texte vide l'efface, et c'est voulu. */
  majNouvellesCirconstances: (liaisonTrackingId, nouvellesCirconstances) =>
    axiosInstance.patch(`/v1/liaisons/${liaisonTrackingId}/nouvelles-circonstances`,
      { nouvellesCirconstances }),

  detacher: (sinistreTrackingId) =>
    axiosInstance.delete(`/v1/sinistres/${sinistreTrackingId}/liaison`),
};
